import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getOptionsWithTranslateHeader } from '@os-components';

export interface GearOilOverviewItem {
    lubricant: string;
    lubricantType: string;
    viscosity: string;
    characteristics?: Array<{
        id: string;
        name: string;
    }>;
    availableSizes: [
        {
            id: string;
            quantity: string;
            unit: string;
            partNumber: string;
        }
    ];
    approvedGearbox: Array<{
        id: string;
        name: string;
    }>;
}

@Injectable({
    providedIn: 'root',
})
export class GearOilOverviewService {
    public constructor(private http: HttpClient) {}

    public getGearOilOverview() {
        return this.http.get<GearOilOverviewItem[]>('/api/gear-oil/overview', {
            ...getOptionsWithTranslateHeader(),
        });
    }
}
